import axios from "../helpers/axios";

const cleanId = (value) => String(value?._id || value?.id || value || "").trim();

export const getUserProfileCard = async (userId, context = {}) => {
    const targetId = cleanId(userId);
    if (!targetId) throw new Error("Не указан пользователь");

    const params = {};
    const chatId = cleanId(context?.chatId);
    const officeId = cleanId(context?.officeId);

    if (chatId) params.chatId = chatId;
    if (officeId) params.officeId = officeId;

    const response = await axios.get(`/user/${encodeURIComponent(targetId)}/profile-card`, {
        params,
    });

    return response?.data || null;
};

export default getUserProfileCard;
